import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Aurora from '../../components/Aurora/Aurora';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import './FAQ.css';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [navbarHidden, setNavbarHidden] = useState(false);
    const lastScrollY = useRef(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const viewportHeight = window.innerHeight;

            if (currentScrollY > lastScrollY.current && currentScrollY > viewportHeight) {
                setNavbarHidden(true);
            } else {
                setNavbarHidden(false);
            }
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const faqs = [
        {
            question: "What is My Digital Schools?",
            answer: "My Digital Schools is a comprehensive educational platform that unifies access to various digital learning providers. Using our Single Sign-On (SSO) technology, students and teachers can access all their resources with just one login."
        },
        {
            question: "How does the Single Sign-On (SSO) work?",
            answer: "Once you log in to My Digital Schools using your school credentials, our system securely authenticates you with all connected provider applications. You won't need to remember separate passwords for Boclips, Coursera, or other integrated tools."
        },
        {
            question: "Is my data secure?",
            answer: "Yes, data security is our top priority. We use industry-standard encryption protocols and strictly adhere to privacy regulations to ensure your personal and educational data remains safe and confidential."
        },
        {
            question: "Can I access the platform from home?",
            answer: "Absolutely! My Digital Schools is a cloud-based platform, meaning you can access your dashboard and learning materials from any device with an internet connection, anywhere in the world."
        },
        {
            question: "What if I forget my password?",
            answer: "If you forget your password, simply click the 'Forgot Password' link on the login page. You'll receive an email or SMS (depending on your account settings) to securely reset your credentials."
        },
        {
            question: "How can schools integrate new providers?",
            answer: "School administrators can manage provider subscriptions directly from the School Dashboard. We are constantly adding new partners; if you have a specific request, please contact our support team."
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="faq-page">
            <Navbar className={navbarHidden ? 'hidden' : ''} />

            {/* Aurora header */}
            <div className="faq-aurora hero-section">
                <div className="aurora-wrapper">
                    <Aurora
                        colorStops={["#0088FF", "#4ecdc4", "#1E40AF"]}
                        blend={0.8}
                        amplitude={1.2}
                        speed={0.3}
                    />
                </div>
            </div>

            <div className="faq-content">
                <div className="faq-container">
                    <header className="faq-header">
                        <h1 className="section-title">Frequently Asked Questions</h1>
                        <p>Everything you need to know about My Digital Schools</p>
                    </header>

                    <div className="faq-grid">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                                onClick={() => toggleFAQ(index)}
                            >
                                <button className="faq-question">
                                    {faq.question}
                                    <svg className="faq-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                <div className="faq-answer">
                                    <div className="faq-answer-content">
                                        {faq.answer}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="faq-contact">
                        <h3>Still have questions?</h3>
                        <p>Can't find the answer you're looking for? Please chat to our friendly team.</p>
                        <a href="/contact" className="contact-button">Contact Support</a>
                    </div>
                </div>
            </div>
            <Footer />
            <ScrollToTop />
        </div>
    );
};

export default FAQ;
